<template>
  <div class="w-100 h-100">
    <v-client-table
      v-if="viewableProducts && viewableProducts.length > 0"
      :key="tableKey"
      ref="storefrontTable"
      :data="viewableProducts"
      :columns="storefrontTableColumns"
      :options="storefrontTableOptions"
      @row-click="rowClicked"
    >
      <template #afterTable>
        <div v-if="!hideFooter" class="after-filter-slot position-relative">
          <a
            v-if="viewableProducts && viewableProducts.length > 1 && !hidePoweredByLogo"
            :href="industry == 'cannabis' ? 'apextrading.com' : 'bushel44.com'"
            target="blank"
          >
            <img
              :src="industry == 'cannabis' ? '/img/icons/logo-apex-powered.svg' : '/img/icons/logo-bushel-powered.svg'"
              alt="Store Cart"
              height="50px"
              width="150px"
              style="position: relative; left: 20px"
            />
          </a>
          <div v-if="viewableProducts && viewableProducts.length > 1" class="float-right mb-2 mr-2" style="position: relative">
            <BushelBtn
              v-if="onDeckCount"
              class="d-inline-block mr-2"
              :disabled="onDeckError"
              :variant="disableStorefrontTheme ? 'success' : ''"
              :class="disableStorefrontTheme ? '' : 'templateButton'"
              :ripple="false"
              @click="addAllOnDeck"
            >
              {{ `add (${Math.floor(onDeckCount * 100) / 100}) Queued Units` }}
            </BushelBtn>
            <div v-if="!hidePerPage" class="text-center d-inline-block" :class="disableStorefrontTheme ? '' : 'templateDropdown'">
              <b-dropdown
                v-if="viewableProducts.length > 5"
                id="dropdown-1"
                alignment="right"
                :label="String(storefrontTableOptions.perPage)"
                class="rounded"
                :class="disableStorefrontTheme ? '' : 'templateButton'"
                :variant="disableStorefrontTheme ? 'success' : ''"
              >
                <b-dropdown-item
                  v-for="option in limitOptions"
                  :key="option"
                  :active="storefrontTableOptions.perPage == option"
                  @click="setPageLimit(option)"
                >
                  {{ option }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>
      </template>
      <template #beforeTable>
        <div
          v-if="!hideHeader"
          :class="`after-filter-slot ${
            theme && theme.page_product_layout_rounded_corners_visible ? 'rounded-top' : 'rounded-top'
          } row p-3 mx-0 align-items-center`"
          style="background: #eaebf0"
        >
          <div class="text-center col-12 col-md-9 col-offset-md-2 my-auto">
            <div v-if="productCategories && productCategories.length >= 1" class="d-inline-block" style="background: #eaebf0">
              <div class="d-inline-block">
                <div class="text-left text-wrap headerDropdown text-center">
                  <BushelBtn
                    v-for="category in productCategories"
                    :key="category.id"
                    class="text-sm m-1 border-0"
                    :variant="activeCategory.id == category.id ? 'primary' : 'secondary'"
                    :flat="activeCategory.id != category.id"
                    @click="initiateCategoryChange(category)"
                  >
                    <!-- :class="
                  disableStorefrontTheme ?
                  activeCategory.id != category.id ? 'secondary border-0 text-secondary' : 'bg-primary border-0 text-white'
                  : activeCategory.id != category.id
                    ? 'secondary border-0'
                    : 'templateButton border-0 text-white'
                " -->
                    <div>
                      <img :src="getImageSrc(category)" />
                      <p class="mb-0" :class="activeCategory.id != category.id ? 'text-secondary' : 'text-white'">
                        {{ category.name }}
                      </p>
                    </div>
                  </BushelBtn>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 d-flex justify-content-end align-items-center border-left">
            <div v-if="showContactSalesButton" class="d-inline-block" style="background: #eaebf0">
              <BushelBtn
                btn-container-class="px-2"
                :class="disableStorefrontTheme ? '' : 'bg-white inverted-storefront-color'"
                :variant="disableStorefrontTheme ? 'primary' : 'light'"
                :ripple="false"
                @click="$emit('contactButtonClicked')"
              >
                <i class="far fa-envelope" />
                Contact Sales
              </BushelBtn>
            </div>
            <BushelBtn
              v-if="isFilterable"
              class="text-center text-md-right mt-0 btn-sm"
              variant="dark"
              outline
              @click="toggleFilters(!storefrontTableOptions.filterable)"
            >
              <span v-if="storefrontTableOptions.filterable == false">Show Filters</span>
              <span v-if="storefrontTableOptions.filterable != false">Hide Filters</span>
            </BushelBtn>
            <!-- :class="disableStorefrontTheme ? '' : 'templateDropdown'" -->

            <div class="text-center text-md-right d-inline-block">
              <b-dropdown
                v-if="viewableProducts.length > 5"
                id="dropdown-1"
                alignment="right"
                :label="String(storefrontTableOptions.perPage)"
                class="mt-0 ml-2"
                size="sm"
                style="background: #eaebf0"
              >
                <!-- :class="disableStorefrontTheme ? '' : 'templateButton'"
            :variant="disableStorefrontTheme ? 'primary' : ''" -->
                <b-dropdown-item
                  v-for="option in limitOptions"
                  :key="option"
                  :active="storefrontTableOptions.perPage == option"
                  @click="setPageLimit(option)"
                >
                  {{ option }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-if="storefrontTableOptions.filterable != false" class="d-inline-block ml-2">
              <b-dropdown id="product_columns_dropdown" alignment="right" class="mt-0" size="sm" outline :label="'Columns'">
                <div class="px-3">
                  <div v-if="isTheSeller" class="custom-checkbox">
                    <input
                      id="show_sku_column"
                      v-model="columnsEnabled.product_sku"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'sku', columnsEnabled.product_sku)"
                    />
                    <label for="show_sku_column" class="clickable">
                      <span />
                      Sku
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_brand_column"
                      v-model="columnsEnabled.brand"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'brand', columnsEnabled.brand)"
                    />
                    <label for="show_brand_column" class="clickable">
                      <span />
                      {{ "Brand" }}
                    </label>
                  </div>
                  <div v-if="showMedRecDesignations" class="custom-checkbox">
                    <input
                      id="industry_column"
                      v-model="columnsEnabled.industry"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'industry', columnsEnabled.industry)"
                    />
                    <label for="industry_column" class="clickable">
                      <span />
                      Industry
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_batch_column"
                      v-model="columnsEnabled.batch_name"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'batch_name', columnsEnabled.batch_name)"
                    />
                    <label for="show_batch_column" class="clickable">
                      <span />
                      Batch
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_operation_column"
                      v-model="columnsEnabled.operation"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'operation', columnsEnabled.operation)"
                    />
                    <label for="show_operation_column" class="clickable">
                      <span />
                      Location
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_cultivar_column"
                      v-model="columnsEnabled.cultivar_name"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'cultivar_name', columnsEnabled.cultivar_name)"
                    />
                    <label for="show_cultivar_column" class="clickable">
                      <span />
                      Cultivar
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_cultivar_type_column"
                      v-model="columnsEnabled.cultivar_type"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'cultivar_type', columnsEnabled.cultivar_type)"
                    />
                    <label for="show_cultivar_type_column" class="clickable">
                      <span />
                      Cultivar Type
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_additional_cannabinoids_column"
                      v-model="columnsEnabled.additional_cannabinoids"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'additional_cannabinoids', columnsEnabled.additional_cannabinoids)"
                    />
                    <label for="show_additional_cannabinoids_column" class="clickable">
                      <span />
                      Additional Cannabinoids
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_terpenes_column"
                      v-model="columnsEnabled.terpenes"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'additional_cannabinoids', columnsEnabled.terpenes)"
                    />
                    <label for="show_terpenes_column" class="clickable">
                      <span />
                      Terpenes
                    </label>
                  </div>
                  <div v-if="scope == 'batch'" class="custom-checkbox">
                    <input
                      id="show_harvest_date_column"
                      v-model="columnsEnabled.harvest_date"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'harvest_date', columnsEnabled.harvest_date)"
                    />
                    <label for="show_harvest_date_column" class="clickable">
                      <span />
                      Harvest Date
                    </label>
                  </div>
                  <div v-if="scope == 'batch'" class="custom-checkbox">
                    <input
                      id="show_extraction_date_column"
                      v-model="columnsEnabled.extraction_date"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'extraction_date', columnsEnabled.extraction_date)"
                    />
                    <label for="show_extraction_date_column" class="clickable">
                      <span />
                      Extraction Date
                    </label>
                  </div>
                  <div v-if="scope == 'batch'" class="custom-checkbox">
                    <input
                      id="show_production_date_column"
                      v-model="columnsEnabled.production_date"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'production_date', columnsEnabled.production_date)"
                    />
                    <label for="show_production_date_column" class="clickable">
                      <span />
                      Production Date
                    </label>
                  </div>
                  <div v-if="scope == 'batch'" class="custom-checkbox">
                    <input
                      id="show_best_by_date_column"
                      v-model="columnsEnabled.best_by_date"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'best_by_date', columnsEnabled.best_by_date)"
                    />
                    <label for="show_best_by_date_column" class="clickable">
                      <span />
                      Expiration Date
                    </label>
                  </div>
                  <div class="custom-checkbox">
                    <input
                      id="show_for_pets_column"
                      v-model="columnsEnabled.for_pets"
                      type="checkbox"
                      @change="handleSetColumn(activeCategory.name, 'for_pets', columnsEnabled.for_pets)"
                    />
                    <label for="show_for_pets_column" class="clickable">
                      <span />
                      For Pets
                    </label>
                  </div>
                </div>
              </b-dropdown>
            </div>
            <BushelBtn
              v-if="onDeckCount"
              :disabled="onDeckError"
              class=""
              :class="`d-inline-block ml-2 btn-sm ${disableStorefrontTheme ? '' : 'templateButton'}`"
              :variant="disableStorefrontTheme ? 'success' : ''"
              :ripple="false"
              @click="addAllOnDeck"
            >
              {{ `Add (${Math.floor(onDeckCount * 100) / 100}) Queued Units` }}
            </BushelBtn>
          </div>
        </div>
      </template>

      <template #filter__for_pets>
        <div class="custom-checkbox">
          <input id="pets_checkbox" v-model="filterByPets" type="checkbox" @change="toggleFilter('for_pets', filterByPets)" />
          <label for="pets_checkbox" class="clickable pl-3">
            <span />
          </label>
        </div>
      </template>
      <template #filter__inline_form>
        <div class="text-left headerDropdown text-center">
          <label class="d-inline-block text-small"> Grouped By </label>
          <b-dropdown
            id="dropdown-3"
            alignment="right"
            :label="activeGroupByTab"
            class="rounded d-inline-block ml-1"
            size="sm"
            toggle-class="text-sm"
            :variant="disableStorefrontTheme ? 'primary' : ''"
          >
            <b-dropdown-item v-for="tab in groupByTabs" :key="tab.name" :active="activeGroupByTab == tab.name" @click="changeGroupByTab(tab.name)">
              {{ tab.displayName }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
      <template #image="props">
        <div class="text-center" @click.stop.prevent>
          <div v-if="props.row.images && props.row.images[0]" class="d-inline-block">
            <div v-for="image in props.row.images" :key="image.id">
              <img
                v-if="image.sort_order == 1"
                :src="image.imageLink"
                class="storefront-product-thumb"
                @mouseover="showImagePreview = props.row.images"
                @mouseleave="showImagePreview = []"
              />
            </div>
          </div>
        </div>
      </template>
      <template #brand="props">
        <div class="text-center">
          <div v-if="isBeingUsedInMarketView">
            <div v-if="props.row.company">
              <p class="text-one-line-with-ellipsis mb-0" style="max-width: 200px">
                {{ props.row.company.name }}
              </p>
            </div>
            <div v-if="props.row.brand">
              <p class="text-one-line-with-ellipsis mb-0" style="max-width: 200px">({{ props.row.brand.name }})</p>
            </div>
          </div>
          <div v-else-if="props.row.brand">
            <p class="text-one-line-with-ellipsis mb-0" style="max-width: 200px">
              {{ props.row.brand.name }}
            </p>
          </div>
        </div>
      </template>
      <template #product_name="props">
        <div class="text-center">
          <div class="d-inline-block">
            <div class="d-flex justify-content-center align-items-center">
              <img v-if="props.row.featured && !isBeingUsedInMarketView" src="img/icons/feature-star-static.png" style="height: 25px" class="mr-1" />
              <p class="mb-0" />
              <p class="mb-0" style="max-width: 300px">
                {{ props.row.product_name }}
              </p>
            </div>
            <div v-if="props.row.for_pets">
              <div v-if="props.row.for_pets" class="d-inline">
                <i
                  :id="`filteringByPets${props.row.id}`"
                  class="fas fa-paw"
                  :style="{
                    color: disableStorefrontTheme ? '' : theme && theme.page_button_color,
                  }"
                />
                <BTooltip :target="`filteringByPets${props.row.id}`" triggers="hover"> Pet Product </BTooltip>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #industry="props">
        <div v-if="showMedRecDesignations" class="text-center">
          <TableMedRec :product="props.row" />
        </div>
      </template>
      <template #batch_name="props">
        <div class="text-center">
          <div v-if="props.row.batches">
            <div v-if="props.row.batches.length == 1">
              <span>{{ props.row.batches[0].name }} </span>
            </div>
            <span v-else> Multiple </span>
          </div>
        </div>
      </template>
      <template #operation="props">
        <div class="text-center">
          <div v-if="productHasOnlyOneOperation(props.row)">
            <span> {{ props.row.batches[0].operation.name }} </span>
            <span class="nowrap text-small d-block">
              ({{ props.row.batches[0].operation.city }} {{ props.row.batches[0].operation.state ? props.row.batches[0].operation.state.value : "" }},
              {{ props.row.batches[0].operation.country ? props.row.batches[0].operation.country.value : "" }})
            </span>
          </div>
          <div v-else>Multiple</div>
        </div>
      </template>
      <template #extract_type="props">
        <div class="text-center">
          {{ props.row.product_type }}
        </div>
      </template>
      <template #germination_rate="props">
        <div class="text-center">
          {{ props.row.germination_rate ? `${props.row.germination_rate} %` : "" }}
        </div>
      </template>
      <template #packaged_unit_size_options="props">
        <div class="text-center">
          {{ pdpSizesAvailable(props.row) }}
        </div>
      </template>
      <template #unit_size="props">
        <div class="text-center">
          {{
            props.row.unit_size
              ? `${props.row.unit_size} ${props.row.product_unit_size_unit_of_measurement ? props.row.product_unit_size_unit_of_measurement : ""}`
              : ""
          }}
        </div>
      </template>
      <template #herm_male_rate="props">
        <div class="text-center">
          {{ props.row.herm_male_rate ? `${Math.round(props.row.herm_male_rate * 100) / 100} %` : "" }}
        </div>
      </template>
      <template #predominate_canabinoid="props">
        <div class="text-center">
          <span>{{ calculateStorefrontPotencyDisplay(props.row) }} </span>
        </div>
      </template>
      <template #additional_cannabinoids="props">
        <div class="text-center">
          <p v-for="(cb, index) in getAdditionalCannabnoids(props.row).splice(0, 3)" :key="index" class="m-0">
            <span v-if="cb.min != cb.max">{{ cb.name }} - {{ cb.min }}{{ cb.type }} - {{ cb.max }}{{ cb.type }}</span>
            <span v-else>{{ cb.name }} - {{ cb.min }}{{ cb.type }}</span>
          </p>
        </div>
      </template>
      <template #terpenes="props">
        <div class="text-center">
          <p v-for="(cb, index) in getTerpenes(props.row).splice(0, 3)" :key="index + 1" class="m-0">
            <span v-if="cb.min != cb.max">{{ cb.name }} : {{ cb.min }}{{ cb.type }} - {{ cb.max }}{{ cb.type }}</span>
            <span v-else class="text-nowrap">{{ cb.name }} : {{ cb.min }}{{ cb.type }}</span>
          </p>
        </div>
      </template>
      <template #gram_per_preroll="props">
        <div class="text-center">
          {{ props.row.gram_per_preroll ? `${props.row.gram_per_preroll} Grams` : "" }}
        </div>
      </template>
      <template #quantity="props">
        <div class="text-center">
          <div class="d-inline">
            <p class="mb-0 font-weight-bolder">
              <span>{{ calculateStorefrontListingQuantity(props.row) }}</span>
              {{ getUnit(props.row).name }}
              <span v-if="props.row.units_per_package || props.row.units_per_case" class="mb-0 text-sm">
                <InfoTooltipBase :id="`${props.row.id}-package-case-tooltip-table`" :text="getFullUnitBreakdown(props.row)" />
                <!-- {{ getFullUnitBreakdown(props.row) }} -->
              </span>
            </p>
            <div class="text-sm">
              <p v-if="isTheSeller && (props.row.units_per_package || props.row.units_per_case)" class="mb-0">
                {{ getPackageCaseOptions(props.row) }}
              </p>
              <p v-if="getUnitSize(props.row) && getUnitSize(props.row).length" class="mb-0">Weight: {{ getUnitSize(props.row) }}</p>
              <p v-if="props.row.packaged_unit_size" class="mb-0">Package Size: {{ props.row.packaged_unit_size }}</p>
              <p v-if="props.row.gram_per_preroll" class="mb-0">Weight: {{ props.row.gram_per_preroll }} Grams</p>

              <p v-if="pdpSizesAvailable(props.row) && pdpSizesAvailable(props.row).length" class="mb-0">Sizes: {{ pdpSizesAvailable(props.row) }}</p>
              <p v-if="quantityInCart(props.row, true)" class="mb-0">({{ quantityInCart(props.row) }} in <i class="fa fa-shopping-cart" />)</p>
              <p v-if="sampleInCart(props.row)" class="mb-0">(Sample in <i class="fa fa-shopping-cart" />)</p>
            </div>
          </div>
          <div v-if="props.row.batches && props.row.batches.length == 1">
            <div v-if="props.row.batches[0].back_order">
              <p :id="`backorder${props.row.batches[0].id}`" class="text-warning mb-0">(Preorder)</p>
              <BTooltip :target="`backorder${props.row.batches[0].id}`" triggers="hover">
                This product is on preorder. You may order it and the seller will fulfill the order when it is available.
                {{
                  props.row.batches[0].back_order.in_stock_expected_date &&
                  `(Expected to be in stock on ${props.row.batches[0].back_order.in_stock_expected_date})`
                }}
              </BTooltip>
            </div>
            <div v-if="props.row.batches[0].restricted">
              <p :id="`restricted${props.row.batches[0].id}`" class="text-danger mb-0">(Restricted)</p>
              <BTooltip :target="`restricted${props.row.batches[0].id}`" triggers="hover">
                This product is restricted but you are authorized to add it to orders.
              </BTooltip>
            </div>
            <div v-if="props.row.hasOnDeckBatches">
              <i :id="`hasOnDeckBatches${props.row.batches[0].id}`" class="fas fa-layer-group text-success" />
              <BTooltip :target="`hasOnDeckBatches${props.row.batches[0].id}`" triggers="hover">
                On Deck Batches exist that will be made available when all active batches sell out.
              </BTooltip>
            </div>
          </div>
        </div>
      </template>
      <template #preroll_type="props">
        <div class="text-center">
          {{ props.row.product_type }}
        </div>
      </template>
      <template #cartridge_type="props">
        <div class="text-center">
          {{ props.row.product_type }}
        </div>
      </template>
      <template #listing_price="props">
        <div class="text-nowrap">
          <div v-if="props.row.category_name != 'Pack To Order'">
            <div v-if="isDiscountedProduct(props.row)">
              <del class="text-danger d-block small font-weight-light">{{ getProductMinMaxPrice(props.row) }}</del>
              <span class="font-weight-normal">{{ getProductTierMinMaxPrice(props.row) }}</span>
            </div>
            <div v-else-if="props.row.sale_price">
              <del class="text-success">{{ getProductMinMaxPrice(props.row) }}</del>
              <span>{{ currency(props.row.sale_price) }}</span>
            </div>
            <div v-else>
              {{ getProductMinMaxPrice(props.row) }}
            </div>
          </div>
          <div v-else>
            <span class="m-0">
              ${{
                countDecimals(ptoGetMinPrice(props.row.batches[0]) / 100) > 0
                  ? (ptoGetMinPrice(props.row.batches[0]) / 100).toFixed(2)
                  : ptoGetMinPrice(props.row.batches[0]) / 100
              }}
            </span>
            <span v-if="ptoGetMaxPrice(props.row.batches[0]) != ptoGetMinPrice(props.row.batches[0])" class="m-0"
              >- ${{
                countDecimals(ptoGetMaxPrice(props.row.batches[0]) / 100) > 0
                  ? (ptoGetMaxPrice(props.row.batches[0]) / 100).toFixed(2)
                  : ptoGetMaxPrice(props.row.batches[0]) / 100
              }}
            </span>
          </div>
          <div v-if="!hidePrices && props.row.batches && props.row.batches.length == 1">
            <span
              v-for="value in getUnitMeasurementPriceBreakdown(props.row, props.row.batches[0])"
              :key="value"
              class="badge border mr-1 text-small"
            >
              {{ value }}</span
            >
            <div v-if="isTheSeller && props.row.batches[0].minimum_sales_price">
              <span class="text-danger text-sm"
                ><b> Min Price ${{ props.row.batches[0].minimum_sales_price / 100 }} </b></span
              >
            </div>
          </div>
        </div>
      </template>
      <template #harvest_date="props">
        <div class="text-nowrap">
          {{ props.row.batches[0].harvest_date }}
        </div>
      </template>
      <template #extraction_date="props">
        <div class="text-nowrap">
          {{ props.row.batches[0].extraction_date }}
        </div>
      </template>
      <template #production_date="props">
        <div class="text-nowrap">
          {{ props.row.batches[0].production_date }}
        </div>
      </template>
      <template #best_by_date="props">
        <div class="text-nowrap">
          {{ props.row.batches[0].best_by_date }}
        </div>
      </template>
      <template #inline_form="props">
        <div class="text-nowrap no-pdp-click">
          <div v-if="props.row.batches && props.row.batches.length > 1">
            <div :class="showChat ? 'btn-group w-100' : ''">
              <StoreFrontChat
                v-if="showChat"
                :authorized="user ? true : false"
                :user="user"
                :from-company-id="user.current_company_id"
                :to-company-id="props.row.company.id"
                :to-company-uuid="props.row.company.uuid"
                :to-company-name="props.row && props.row.company && props.row.company.name ? props.row.company.name : null"
                class="d-inline-block rounded"
                btn-class="btn-sm"
                icon-style="font-size: 14px;"
                btn-style="height: 37px;"
              />
              <BushelBtn
                :ripple="false"
                class="btn-block ml-2 w-100 rounded"
                inline-form-class
                btn-content-class="no-pdp-click"
                btn-container-class="no-pdp-click"
                :disabled="buyer && buyer.hold"
                :class="disableStorefrontTheme ? '' : 'templateButton'"
                :variant="disableStorefrontTheme ? 'success' : ''"
                @click="openMultipleBatchModal(props.row)"
              >
                <i class="fas fa-bars no-pdp-click" />
              </BushelBtn>
            </div>
          </div>
          <!-- This shouldn't be shown, but just in case it is -->
          <div v-else-if="props.row.batches[0].hold">
            <p class="mb-0">
              On Deck <i :id="`holdinputsection${props.row.batches[0].id}`" class="fas fa-question text-info cursor-default" />

              <BTooltip :target="`holdinputsection${props.row.batches[0].id}`" triggers="hover" placement="left">
                This Batch is On Deck and can be ordered once available batches have sold out.
              </BTooltip>
            </p>
          </div>
          <div v-else-if="props.row.category_name != 'Pack To Order'" :key="inputSlotKey" class="d-flex">
            <StoreFrontChat
              v-if="showChat"
              :authorized="user ? true : false"
              :user="user"
              :from-company-id="user.current_company_id"
              :to-company-id="props.row.company.id"
              :to-company-uuid="props.row.company.uuid"
              :to-company-name="props.row && props.row.company && props.row.company.name ? props.row.company.name : null"
              class="d-inline-block rounded"
              btn-class="btn-sm"
              icon-style="font-size: 14px;"
              btn-style="height: 37px;"
            />

            <BushelTextInput
              :key="`input key ${props.row.id}`"
              :error="onDeck[props.row.batches[0].id] && (onDeck[props.row.batches[0].id].over_limit || onDeck[props.row.batches[0].id].decimalError)"
              :value="onDeck[props.row.batches[0].id] ? onDeck[props.row.batches[0].id].purchase_quantity : null"
              type="number"
              hide-label
              :disabled="checkIfLoading(props.row) || (buyer && buyer.hold)"
              input-class="no-pdp-click"
              name="onDeckQuantity"
              no-bottom-padding
              class="flex-grow-1"
              :number-type-allow-decimal="categoryTypeCanHaveDecimal(props.row.category_name, props.row)"
              :number-type-max-precision="6"
              @input="
                (val) =>
                  updateOnDeckQuantity({
                    ...props.row,
                    purchase_quantity: val,
                  })
              "
              @input-blurred="
                (val) =>
                  quantityEnteredCheck({
                    ...props.row,
                    purchase_quantity: val,
                  })
              "
              @enter="singleAddCartItem(props.row)"
            />
            <BushelBtn
              v-if="props.row.batches.length == 1"
              :disabled="
                !onDeck[props.row.batches[0].id] ||
                !onDeck[props.row.batches[0].id].purchase_quantity ||
                onDeck[props.row.batches[0].id].over_limit ||
                onDeck[props.row.batches[0].id].decimalError ||
                (buyer && buyer.hold == true)
                  ? true
                  : false
              "
              :ripple="false"
              class="btn-block ml-2"
              btn-content-class="no-pdp-click"
              btn-container-class="no-pdp-click"
              :style="`--btnColor: ${btnColor}; --btnBgColor: ${btnBackgroundColor}`"
              :variant="disableStorefrontTheme ? 'success' : 'custom'"
              @click="singleAddCartItem(props.row)"
            >
              <div
                v-if="
                  checkIfLoading(props.row) &&
                  (!onDeck[props.row.batches[0].id] ||
                    !onDeck[props.row.batches[0].id].purchase_quantity ||
                    onDeck[props.row.batches[0].id].over_limit ||
                    onDeck[props.row.batches[0].id].decimalError)
                "
                class="spinner-border spinner-border-sm"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <i v-if="!checkIfLoading(props.row)" class="fas fa-plus no-pdp-click text-white" />
            </BushelBtn>
          </div>

          <div v-else-if="props.row.category_name == 'Pack To Order'" :class="showChat ? 'btn-group w-100' : ''">
            <StoreFrontChat
              v-if="showChat"
              :authorized="user ? true : false"
              :user="user"
              :from-company-id="user.current_company_id"
              :to-company-id="props.row.company.id"
              :to-company-uuid="props.row.company.uuid"
              :to-company-name="props.row && props.row.company && props.row.company.name ? props.row.company.name : null"
              class="d-inline-block rounded"
              icon-style="font-size: 14px;"
              btn-class="btn-sm"
              btn-style="height: 37px;"
            />
            <BushelBtn
              :ripple="false"
              class="btn-block ml-2 w-100 rounded"
              inline-form-class
              btn-content-class="no-pdp-click"
              :disabled="buyer && buyer.hold"
              :variant="disableStorefrontTheme ? 'success' : ''"
              :btn-container-class="disableStorefrontTheme ? 'no-pdp-click' : 'templateButton no-pdp-click'"
              @click="launchPTOModal(props.row, props.row.batches[0])"
            >
              <i class="fas fa-calculator no-pdp-click" />
            </BushelBtn>
          </div>
          <BushelBtn
            v-if="props.row.batches.length == 1 && props.row.batches[0].samples_available && !props.row.batches[0].hold"
            :disabled="sampleInCart(props.row) || (buyer && buyer.hold)"
            :ripple="false"
            class="btn-block m-0 px-0 mt-1 btn-xs py-2 no-pdp-click"
            btn-content-class="no-pdp-click"
            btn-container-class="no-pdp-click"
            :style="`--btnColor: ${btnColor}; --btnBgColor: ${btnBackgroundColor}`"
            :variant="disableStorefrontTheme ? 'success' : 'custom'"
            @click="addSample(props.row)"
          >
            <span v-if="isTheSeller" class="no-pdp-click">{{ sampleInCart(props.row) ? "Sample Added" : "Add Sample" }}</span>
            <span v-else class="no-pdp-click">{{ sampleInCart(props.row) ? "Sample Requested" : "Request Sample" }}</span>
          </BushelBtn>
        </div>
      </template>
    </v-client-table>
    <ProductDisplayPageModal
      v-if="selectedProduct && selectedProduct.id"
      :key="productDisplayPageModalKey"
      :show="showingProductDisplayModal"
      :company="storefrontCompany"
      :user="user"
      :on-marketplace="isBeingUsedInMarketView"
      :buyer-id="buyer ? buyer.id : null"
      :selected-product="selectedProduct"
      :bulk-discounts="productCurrentlyShowingBulkDiscounts"
      :selected-batch-id="selectedBatchId"
      :hide-prices="hidePrices"
      :hide-quantities="hideQuantities"
      :cart-items="cartItems"
      :disable-add="disableAdd"
      :use-cannabis-spinner="useCannabisSpinner"
      :cart-needs-to-be-chosen="cartNeedsToBeChosen"
      :active-location="activeLocation"
      :order-id="orderId"
      @hide="hideProductDisplayPageModal"
      @added-product="addProductFromDisplayPage"
      @contact-button-clicked="pdpContactClicked"
      @launch-p-t-o-modal="handleLaunchingPTOModalFromPDPModal"
    />
    <MultipleBatchModal
      v-if="isShowingMultiBatchModal"
      :key="multiBatchModalKey"
      :is-the-seller="isTheSeller"
      :show="true"
      :product="selectedProduct"
      :cart-items="cartItems"
      :show-aging-fields="showAgingFields"
      @hide="isShowingMultiBatchModal = false"
      @added-product="createMultiBatchItems"
      @launch-p-t-o-modal="handleLaunchingPTOModalFromMultiBatchModal"
      @launch-product-display-page="launchProductDisplayPageModal({ row: selectedProduct })"
    />
    <PTOModal
      :key="ptoModalKey"
      :show="isShowingPTOModal"
      :product="ptoProduct"
      :batch="ptoBatch"
      :existing-quantity="ptoCurrentQuantity || 0"
      @hide="isShowingPTOModal = false"
      @create-pack-to-order-items="createPackToOrderItems"
    />
    <DeleteConfirmationModal
      id="delete_confirm_modal"
      :title="'Queued Items'"
      :show="isShowingRemoveQueueConfirmationModal"
      header-class="bg-white border-0"
      title-class="text-primary"
      confirm-button-variant="warning"
      hide-cancel-btn
      :alternative-action-btn-text="!onDeckError ? 'Add All' : ''"
      :confirm-text="'Skip'"
      @hide="removeQueueConfirmationModal"
      @confirm="skipAndChangeCategory"
      @alternative-action-btn-clicked="addAndChangeCategory"
    >
      <div class="d-block ml-auto mr-auto text-center">
        <img src="/img/icons/queued-items.svg" alt="Queued Items" max-width="230px" class="ml-auto mr-auto" />
        <h5 class="text-primary mt-3">You have queued items that have not been added to your cart.</h5>
        <h5 class="text-primary mt-3">If you change categories we will reset your queue.</h5>
      </div>
    </DeleteConfirmationModal>
    <div v-show="showImagePreview.length" class="image-floater text-center hidden-print">
      <div>
        <img v-if="showImagePreview.length == 1" :src="showImagePreview[0].imageLink" alt="Product Image" class="mw-100 maxh-80" />
        <BCarousel v-else :images="showImagePreview" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BCarousel from "@/components/base/BCarousel.vue";
import ProductDisplayPageModal from "@/components/productDisplay/ProductDisplayPageModal.vue";
import MultipleBatchModal from "@/components/storefront/multipleBatch/MultipleBatchModal.vue";
import PTOModal from "@/components/storefront/PTOModal.vue";
import TableMedRec from "./TableMedRec.vue";
import InfoTooltipBase from "@/components/common/InfoTooltipBase.vue";
import { currency } from "@/services/filters";

import {
  getFullUnitBreakdown,
  getPackageCaseOptions,
  getUnit,
  getUnitSize,
  calculateStorefrontListingQuantity,
  calculateStorefrontPotencyDisplay,
  pdpSizesAvailable,
  ptoGetMinPrice,
  ptoGetMaxPrice,
  getUnitMeasurementPriceBreakdown,
  getProductMinMaxPrice,
  isDiscountedProduct,
  getProductTierMinMaxPrice,
} from "@/services/storefront/storefront";
import { categoryTypeCanHaveDecimal } from "@/services/inventory/inventory";
import StoreFrontChat from "@/components/storefront/StoreFrontChat.vue";

export default {
  name: "StorefrontTable",
  components: {
    InfoTooltipBase,
    ProductDisplayPageModal,
    MultipleBatchModal,
    PTOModal,
    TableMedRec,
    BCarousel,
    StoreFrontChat,
  },
  props: {
    orderId: { type: Number },
    storefrontCompany: { type: Object, required: true },
    theme: { type: Object },
    products: { type: Array, required: true },
    user: { type: Object },
    buyer: { type: Object, default: null },
    productCategories: { type: Array, required: true },
    bulkDiscounts: { type: Array, required: true },
    tableClass: { type: String },
    tableShadow: { type: Boolean, default: true },
    disableStorefrontTheme: { type: Boolean, default: false },
    hidePrices: { type: Boolean, default: false },
    hideQuantities: { type: Boolean, default: false },
    disableAdd: { type: Boolean, default: false },
    cartNeedsToBeChosen: { type: Boolean, default: false },
    hideFooter: { type: Boolean, default: false },
    hideHeader: { type: Boolean, default: false },
    hidePagination: { type: Boolean, default: false },
    hidePerPage: { type: Boolean, default: false },
    cartItems: { type: Array, required: true },
    hidePoweredByLogo: { type: Boolean, default: false },
    showContactSalesButton: { type: Boolean, default: false },
    limitOverride: { type: Number },
    useCannabisSpinner: { type: Boolean, default: true },
    isTheSeller: { type: Boolean, default: false },
    isFilterable: { type: Boolean, default: true },
    isSortable: { type: Boolean, default: true },
    showBrandColumn: { type: Boolean, default: false },
    showMedRecDesignations: { type: Boolean, default: false },
    activeCategoryOverride: { type: Object },
    isBeingUsedInMarketView: { type: Boolean, default: false },
    chatEnabled: { type: Boolean, default: false },
    activeLocation: { type: Object },
    scope: { type: String, default: "product" },
    showAgingFields: { type: Boolean, default: false },
    defaultColumnsEnabled: { type: Object, default: null },
  },
  emits: ["contactButtonClicked", "addToCart"],
  data() {
    const self = this;
    return {
      slide: 0,
      industry: APP_INDUSTRY,
      tableKey: 34343,
      showImagePreview: [],
      // categoryHasPetProducts: false,
      filteringByPets: "no",
      limitOptions: [5, 10, 20, 50, 100, 500],
      ptoCurrentQuantity: 0,
      onDeck: {},
      currentCount: null,
      activeFilteredOperation: { id: "default", name: "All" },
      activeGroupByTab: "None",
      showingProductDisplayModal: false,
      productCurrentlyShowingBulkDiscounts: [],
      selectedBatchId: null,
      activeCategory: { id: "default", name: "All Products" },
      onHoldCategory: {},
      inputSlotKey: 1234,
      groupByTabs: [],
      selectedProductId: null,
      productDisplayPageModalKey: 400,
      isShowingRemoveQueueConfirmationModal: false,
      multiBatchModalKey: 12341234,
      isShowingMultiBatchModal: false,
      ptoProduct: {},
      ptoBatch: {},
      ptoModalKey: 434,
      isShowingPTOModal: false,
      filterByPets: false,
      filterableDefaults: [
        "operation",
        "category_long_display_name", // hidden with css
        "category_name",
        "product_name",
        "product_sku",
        "batch_name",
        "brand",
        "cultivar_name",
        "predominate_canabinoid",
        "additional_cannabinoids",
        "terpenes",
        "cartridge_type",
        "product_type",
        "preroll_type",
        "extract_type",
        "grow_environment",
        "state_of_material",
        "flowering_period",
        "container_type",
        "storage_type",
        "listing_price",
        "quantity",
        "germination_rate",
        "herm_male_rate",
        "unit_size",
        "packaged_unit_size",
        "packaged_unit_size_options",
        "gram_per_preroll",
        "cultivar_type",
        "industry",
      ],
      columnsEnabled: this.defaultColumnsEnabled
        ? this.defaultColumnsEnabled
        : {
            brand: this.showBrandColumn,
            batch_name: true,
            operation: false,
            for_pets: false,
            cultivar_name: false,
            cultivar_type: false,
            additional_cannabinoids: !!this.isBeingUsedInMarketView,
            terpenes: !!this.isBeingUsedInMarketView,
            industry: this.showMedRecDesignations,
            product_sku: false,
            harvest_date: false,
          },
      storefrontTableOptions: {
        skin: "table table-hover",
        perPage: this.limitOverride ? this.limitOverride : 10,
        highlightMatches: true,
        groupBy: null,
        filterByColumn: true,
        orderBy: {
          column: "product_name",
          ascending: true,
        },
        headings: {
          category_name: "Category",
          image: "",
          product_name: "Product",
          batch_name: "Batch",
          operation: "Location",
          product_type: "Product Type",
          extract_type: "Extract Type",
          preroll_type: "Preroll Type",
          cartridge_type: "Cartridge Type",
          unit_size: "Unit Size / Weight",
          container_type: "Container Type",
          germination_rate: "Germination Rate",
          herm_male_rate: "Feminization Rate",
          brand: "Brand",
          quantity: "Quantity Available",
          listing_price: "Price",
          cultivar_name: "Cultivar",
          cultivar_type: "Cultivar Type",
          additional_cannabinoids: "Additional Cannabinoids",
          terpenes: "Terpenes",
          product_sku: "Sku",
          predominate_canabinoid: "Potency",

          harvest_date: "Harvest Date",
          extraction_date: "Extraction Date",
          production_date: "Production Date",
          best_by_date: "Expiration Date",
          state_of_material: "State Of Material",
          grow_environment: "Grow Environment",
          flowering_period: "Flowering Period",
          gram_per_preroll: "Grams Per Preroll",
          packaged_unit_size: "Packaged Unit Size",
          packaged_unit_size_options: "Available Sizes",

          for_pets: "For Pets",
          inline_form: "",
        },

        filterable: this.isFilterable ? this.filterableDefaults : [],
        sortable: this.isSortable
          ? [
              "operation",
              "product_name",
              "product_sku",
              "category_name",
              "cultivar_type",
              "brand",
              "batch_name",
              "cultivar_name",
              "predominate_canabinoid",
              "additional_cannabinoids",
              "terpenes",
              "cartridge_type",
              "preroll_type",
              "product_type",
              "extract_type",
              "grow_environment",
              "state_of_material",
              "flowering_period",
              "container_type",
              "storage_type",
              "listing_price",
              "quantity",
              "germination_rate",
              "herm_male_rate",
              "unit_size",
              "packaged_unit_size",
              "packaged_unit_size_options",
              "gram_per_preroll",
              "industry",
              "harvest_date",
              "extraction_date",
              "production_date",
              "best_by_date",
            ]
          : [],
        customFilters: [
          {
            name: "quantity",
            callback(row, query) {
              return (
                (row.quantity && calculateStorefrontListingQuantity(row).toString().toLowerCase().includes(query.toLowerCase())) ||
                (row.quantity && getUnit(row) && getUnit(row).name.toString().toLowerCase().includes(query.toLowerCase()))
              );
            },
          },
          {
            name: "operation",
            callback(row, query) {
              return row.operation.name && row.operation.name.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "industry",
            callback(row, query) {
              let searchStringA = "";
              let searchStringB = "";
              let hasMed = false;
              let hasRec = false;
              for (let i = 0; i < row.batches.length; i += 1) {
                if (row.batches[i].operation) {
                  if (row.batches[i].operation.industry == "Medical") {
                    hasMed = true;
                  } else if (row.batches[i].operation.industry == "Recreational") {
                    hasRec = true;
                  }
                }
              }
              if (hasRec) {
                searchStringA += " rec";
              }
              if (hasMed) {
                searchStringA += " med";
              }
              if (hasMed) {
                searchStringB += " med";
              }
              if (hasRec) {
                searchStringB += " rec";
              }
              if (searchStringA.includes(query.toLowerCase())) {
                return true;
              }
              if (searchStringB.includes(query.toLowerCase())) {
                return true;
              }
              return false;
            },
          },
          {
            name: "packaged_unit_size_options",
            callback(row, query) {
              let returnValue = false;
              const available = pdpSizesAvailable(row);
              if (available.toLowerCase().includes(query.toLowerCase())) {
                returnValue = true;
              }
              return returnValue;
            },
          },
          {
            name: "for_pets",
            callback(row, query) {
              if (query == true) {
                return row.for_pets;
              }

              return !row.for_pets;
            },
          },
          {
            name: "unit_size",
            callback(row, query) {
              return row.unit_size && row.unit_size.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "germination_rate",
            callback(row, query) {
              return row.germination_rate && row.germination_rate.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "herm_male_rate",
            callback(row, query) {
              return row.herm_male_rate && row.herm_male_rate.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "brand",
            callback(row, query) {
              return (
                (row.brand && row.brand.name && row.brand.name.toLowerCase().includes(query.toLowerCase())) ||
                (this.isBeingUsedInMarketView && row.company.name && row.company.name.toLowerCase().includes(query.toLowerCase()))
              );
            },
          },
          {
            name: "product_type",
            callback(row, query) {
              return row.product_type && row.product_type.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "preroll_type",
            callback(row, query) {
              return row.product_type && row.product_type.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "cartridge_type",
            callback(row, query) {
              return row.product_type && row.product_type.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "batch_name",
            callback(row, query) {
              if (row.batches && row.batches.length) {
                if (row.batches && row.batches.length > 1) {
                  return "multiple".toLowerCase().includes(query.toLowerCase());
                }
                return row.batches[0].name && row.batches[0].name.toString().toLowerCase().includes(query.toString().toLowerCase());
              }
              return false;
            },
          },
          {
            name: "cultivar_name",
            callback(row, query) {
              return row.cultivar_name && row.cultivar_name.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "cultivar_type",
            callback(row, query) {
              return row.cultivar_type && row.cultivar_type.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "predominate_canabinoid",
            callback(row, query) {
              const data = calculateStorefrontPotencyDisplay(row);
              return data && data.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "product_name",
            callback(row, query) {
              const search = query.toLowerCase();
              return row.product_name && row.product_name.toString().toLowerCase().includes(search);
              // || (row.batch_name && row.batch_name.toString().toLowerCase().includes(seach));
            },
          },
          {
            name: "extract_type",
            callback(row, query) {
              return row.product_type && row.product_type.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "packaged_unit_size",
            callback(row, query) {
              return row.packaged_unit_size && row.packaged_unit_size.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "gram_per_preroll",
            callback(row, query) {
              return row.gram_per_preroll && row.gram_per_preroll.toString().toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "flowering_period",
            callback(row, query) {
              return row.flowering_period && row.flowering_period.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "grow_environment",
            callback(row, query) {
              return row.grow_environment && row.grow_environment.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "container_type",
            callback(row, query) {
              return row.container_type && row.container_type.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "storage_type",
            callback(row, query) {
              return row.storage_type && row.storage_type.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "state_of_material",
            callback(row, query) {
              return row.state_of_material && row.state_of_material.toLowerCase().includes(query.toLowerCase());
            },
          },
          {
            name: "listing_price",
            callback(row, query) {
              let returnable = false;
              row.batches.forEach((batch) => {
                if (batch.listing_price && self.currency(batch.listing_price).toString().toLowerCase().includes(query.toString().toLowerCase())) {
                  returnable = true;
                } else if (
                  batch.tiered_listing_price &&
                  self.currency(batch.tiered_listing_price).toString().toLowerCase().includes(query.toString().toLowerCase())
                ) {
                  returnable = true;
                } else {
                  returnable = false;
                }
              });
              return returnable;
            },
          },
        ],
        customSorting: {
          quantity(ascending) {
            return function (a, b) {
              let lastA = self.batchTotalQuantity(a);
              let lastB = self.batchTotalQuantity(b);

              if (lastA == "infinite") {
                lastA = 1000000000000000000000;
              }
              if (lastB == "infinite") {
                lastB = 1000000000000000000000;
              }
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          listing_price(ascending) {
            return function (a, b) {
              let ABatchesLowestPrice = 0;
              let BBatchesLowestPrice = 0;

              // this just gets the lowest price of the batches.
              if (a.batches.length > 1) {
                const abatch = a.batches.reduce((prev, current) => {
                  if (prev.tiered_listing_price && current.tiered_listing_price) {
                    return prev.tiered_listing_price < current.tiered_listing_price ? prev : current;
                  }
                  return prev.listing_price < current.listing_price ? prev : current;
                });

                ABatchesLowestPrice = abatch.tiered_listing_price ? abatch.tiered_listing_price : abatch.listing_price;
              } else {
                ABatchesLowestPrice = a.batches[0].tiered_listing_price ? a.batches[0].tiered_listing_price : a.batches[0].listing_price;
              }

              if (b.batches.length > 1) {
                const bbatch = b.batches.reduce((prev, current) => {
                  if (prev.tiered_listing_price && current.tiered_listing_price) {
                    return prev.tiered_listing_price < current.tiered_listing_price ? prev : current;
                  }
                  return prev.listing_price < current.listing_price ? prev : current;
                });

                BBatchesLowestPrice = bbatch.tiered_listing_price ? bbatch.tiered_listing_price : bbatch.listing_price;
              } else {
                BBatchesLowestPrice = b.batches[0].tiered_listing_price ? b.batches[0].tiered_listing_price : b.batches[0].listing_price;
              }

              const lastA = ABatchesLowestPrice;
              const lastB = BBatchesLowestPrice;

              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          extract_type(ascending) {
            return function (a, b) {
              const lastA = a.product_type;
              const lastB = b.product_type;
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          cartridge_type(ascending) {
            return function (a, b) {
              const lastA = a.product_type;
              const lastB = b.product_type;
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          preroll_type(ascending) {
            return function (a, b) {
              const lastA = a.product_type;
              const lastB = b.product_type;
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          company(ascending) {
            return function (a, b) {
              const lastA = a.company && a.company.name ? a.company.name : "";
              const lastB = b.company && b.company.name ? b.company.name : "";
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          operation(ascending) {
            return function (a, b) {
              const lastA = a.operation && a.operation.name ? a.operation.name : "";
              const lastB = b.operation && b.operation.name ? b.operation.name : "";
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },

          industry(ascending) {
            return function (a, b) {
              const lastA = {
                hasMed: false,
                hasRec: false,
              };
              for (let i = 0; i < a.batches.length; i += 1) {
                if (a.batches[i].operation) {
                  if (a.batches[i].operation.industry == "Medical") {
                    lastA.hasMed = true;
                  } else if (a.batches[i].operation.industry == "Recreational") {
                    lastA.hasRec = true;
                  }
                }
              }
              const lastB = {
                hasMed: false,
                hasRec: false,
              };
              for (let i = 0; i < b.batches.length; i += 1) {
                if (b.batches[i].operation) {
                  if (b.batches[i].operation.industry == "Medical") {
                    lastB.hasMed = true;
                  } else if (b.batches[i].operation.industry == "Recreational") {
                    lastB.hasRec = true;
                  }
                }
              }

              let lA = 0;
              let lB = 0;

              if (lastA.hasMed) {
                lA += 2;
              }
              if (lastA.hasRec) {
                lA += 1;
              }
              if (lastB.hasMed) {
                lB += 2;
              }
              if (lastB.hasRec) {
                lB += 1;
              }

              if (ascending) {
                return lA > lB ? 1 : -1;
              }
              return lA < lB ? 1 : -1;
            };
          },

          brand(ascending) {
            return function (a, b) {
              const lastA = a.brand && a.brand.name ? a.brand.name : "";
              const lastB = b.brand && b.brand.name ? b.brand.name : "";
              if (ascending) {
                return lastA > lastB ? 1 : -1;
              }
              return lastA < lastB ? 1 : -1;
            };
          },
          predominate_canabinoid(ascending) {
            return function (a, b) {
              let amin = null;
              let bmin = null;
              let amax = null;
              let bmax = null;

              for (let i = 0; i < a.batches.length; i += 1) {
                if (!amin || a.batches[i].predominate_canabinoid_min_or_only < amin) {
                  amin = a.batches[i].predominate_canabinoid_min_or_only;
                }
                if (!amax || a.batches[i].predominate_canabinoid_max > amax) {
                  amax = a.batches[i].predominate_canabinoid_max;
                }
                if (!amax || a.batches[i].predominate_canabinoid_min_or_only > amax) {
                  amax = a.batches[i].predominate_canabinoid_min_or_only;
                }
              }
              for (let i = 0; i < b.batches.length; i += 1) {
                if (!bmin || b.batches[i].predominate_canabinoid_min_or_only < bmin) {
                  bmin = b.batches[i].predominate_canabinoid_min_or_only;
                }
                if (!bmax || b.batches[i].predominate_canabinoid_max > bmax) {
                  bmax = b.batches[i].predominate_canabinoid_max;
                }
                if (!bmax || b.batches[i].predominate_canabinoid_min_or_only > bmax) {
                  bmax = b.batches[i].predominate_canabinoid_min_or_only;
                }
              }

              if (ascending) {
                return amin > bmin ? 1 : -1;
              }
              return amax < bmax ? 1 : -1;
            };
          },
        },
        texts: {
          limit: "Page Limit",
          noResults: "No Matching Product",
        },
        columnsClasses: {
          category_long_display_name: "d-none",
          brand: "max-300px",
          for_pets: "no-wrap text-left ml-1",
          inline_form: "min-100px max-150px",
          harvest_date: "min-200px max-250px text-nowrap",
          extraction_date: "min-200px max-250px text-nowrap",
          production_date: "min-200px max-250px text-nowrap",
          best_by_date: "min-200px max-250px text-nowrap",
        },
        uniqueKey: "uniqueKey",
      },
      storefrontTableColumns: [],
    };
  },

  computed: {
    ...mapState("shippingOrders", ["itemsLoading"]),
    btnBackgroundColor() {
      if (this.disableStorefrontTheme) {
        return "var(--success)";
      }

      return this.theme && this.theme.page_button_color ? this.theme.page_button_color : "var(--success)";
    },
    viewableProducts() {
      return this.products.filter((product) => product.batches.some((batch) => !batch.hold));
    },
    btnColor() {
      return this.theme && this.theme.page_button_text_color ? this.theme.page_button_text_color : "#ffffff";
    },
    selectedProduct() {
      if (this.selectedProductId) {
        const foundProduct = this.viewableProducts.find((product) => product.id == this.selectedProductId);
        if (foundProduct && foundProduct.batches.length) {
          return foundProduct;
        }
      }
      return {};
    },
    onDeckError() {
      let error = false;

      for (const value of Object.values(this.onDeck)) {
        if (value.over_limit || value.decimalError) {
          error = true;
        }
      }

      return error;
    },
    onDeckCount() {
      let total = 0;

      for (const value of Object.values(this.onDeck)) {
        total += Number(value.purchase_quantity);
      }

      return total;
    },
    cssVars() {
      return {
        "--bg-color": this.theme && this.theme.page_button_color,
        "--color": this.theme && this.theme.page_button_text_color.value,
        "border-radius": this.theme && !this.theme.page_product_layout_rounded_corners_visible ? "0 !important" : "",
      };
    },
    showChat() {
      if (this.chatEnabled && this.user && this.user.current_company_id) {
        return true;
      }
      return false;
    },
  },
  watch: {
    limitOverride(oldVal, newVal) {
      if (oldVal != newVal) {
        this.storefrontTableOptions.perPage = this.limitOverride;
      }
    },
    scope(o, n) {
      this.setTableColumns(this.activeCategory.name);
    },
    defaultColumnsEnabled: {
      handler(o, n) {
        this.columnsEnabled = n;
        this.setTableColumns(this.activeCategory.name);
      },
      deep: true,
    },

    // hidePrices(o, n) {
    //   if (this.productCategories[0]) {
    //     this.continueChangingTab(this.productCategories[0]);
    //   }
    // },
    // hideQuantities(o, n) {
    //   if (this.productCategories[0]) {
    //     this.continueChangingTab(this.productCategories[0]);
    //   }
    // },
  },

  mounted() {
    if (this.productCategories[0] || this.activeCategoryOverride) {
      const category = this.activeCategoryOverride ? this.activeCategoryOverride : this.productCategories[0];
      this.continueChangingTab(category);
    }
    this.filterable = this.toggleFilters(this.isFilterable);
  },
  updated() {
    if (!this.activeCategory.id || (this.activeCategoryOverride && this.activeCategoryOverride.id != this.activeCategory.id)) {
      const category = this.activeCategoryOverride ? this.activeCategoryOverride : this.productCategories[0];
      this.continueChangingTab(category);
    }
  },
  methods: {
    getPackageCaseOptions,
    getFullUnitBreakdown,
    getUnit,
    getUnitSize,
    calculateStorefrontListingQuantity,
    calculateStorefrontPotencyDisplay,
    categoryTypeCanHaveDecimal,
    pdpSizesAvailable,
    ptoGetMinPrice,
    ptoGetMaxPrice,
    getUnitMeasurementPriceBreakdown,
    getProductMinMaxPrice,
    isDiscountedProduct,
    getProductTierMinMaxPrice,
    currency,
    batchTotalQuantity(product) {
      let batchTotalQuantity = 0;
      product.batches.forEach((batch, index) => {
        if (batch.disable_inventory_tracking) {
          batchTotalQuantity = "infinite";
        } else if (batchTotalQuantity != "infinite") {
          batchTotalQuantity += batch.quantity;
        }
      });
      return batchTotalQuantity;
    },
    toggleFilters(toggle) {
      if (!toggle) {
        this.storefrontTableOptions.filterable = false;
      } else {
        this.storefrontTableOptions.filterable = this.filterableDefaults;
      }
      this.tableKey += 1;
    },
    // toggleColumn(column) {
    //   this.columnsEnabled[column] = !this.columnsEnabled[column];
    //   this.setTableColumns(this.activeCategory.name);
    // },
    checkIfLoading(productOrBatch) {
      // items loading is the batch id;
      if (this.itemsLoading.length > 0) {
        if (productOrBatch.batches) {
          for (let i = 0; i < productOrBatch.batches.length; i += 1) {
            if (this.itemsLoading.includes(productOrBatch.batches[i].id)) {
              return true;
            }
          }
        } else if (this.itemsLoading.includes(productOrBatch.id)) {
          return true;
        }

        return false;
      }

      return false;
    },
    addAndChangeCategory() {
      if (!this.onDeckError) {
        this.addAllOnDeck();
        this.continueChangingTab(this.onHoldCategory);
        this.onHoldCategory = {};
      }
    },
    handleLaunchingPTOModalFromMultiBatchModal(val) {
      this.isShowingMultiBatchModal = false;
      this.launchPTOModal(val.product, val.batch);
    },
    handleLaunchingPTOModalFromPDPModal(val) {
      this.hideProductDisplayPageModal();
      this.launchPTOModal(val.product, val.batch);
    },
    launchPTOModal(product, batch) {
      this.ptoProduct = { ...product };
      this.ptoBatch = { ...batch };
      this.ptoCurrentQuantity = this.quantityInCart(product, true);
      this.ptoModalKey += 1;
      this.isShowingPTOModal = true;
    },
    skipAndChangeCategory() {
      this.continueChangingTab(this.onHoldCategory);
      this.onHoldCategory = {};
    },
    productHasOnlyOneOperation(product) {
      let opId = null;
      let onlyOneOperation = true;
      for (let i = 0; i < product.batches.length; i += 1) {
        if (product.batches[i].operation && product.batches[i].operation.id) {
          if (opId == null || opId == product.batches[i].operation.id) {
            opId = product.batches[i].operation.id;
          } else {
            onlyOneOperation = false;
            break;
          }
        }
      }
      return onlyOneOperation;
    },
    getAdditionalCannabnoids(product) {
      const additionals = [];
      if (product.batches) {
        product.batches.forEach((batch) => {
          if (batch.additional_cannabinoids.length > 0) {
            batch.additional_cannabinoids.forEach((cannabinoid) => {
              if (
                !additionals.some(
                  (additional) => additional.name == cannabinoid.abbreviation && additional.type == cannabinoid.pivot?.measurement_type,
                )
              ) {
                additionals.push({
                  name: cannabinoid.abbreviation,
                  min: cannabinoid.pivot?.measurement,
                  max: cannabinoid.pivot?.measurement,
                  type: cannabinoid.pivot?.measurement_type,
                });
              } else {
                const index = additionals.findIndex(
                  (additional) => additional.name == cannabinoid.abbreviation && additional.type == cannabinoid.pivot?.measurement_type,
                );
                if (cannabinoid.pivot?.measurement < additionals[index].min) {
                  additionals[index].min = cannabinoid.pivot?.measurement;
                }
                if (cannabinoid.pivot?.measurement > additionals[index].max) {
                  additionals[index].max = cannabinoid.pivot?.measurement;
                }
              }
            });
          }
        });
      }
      return additionals.sort((a, b) => {
        if (a.min < b.min && a.max <= b.max) {
          return 1;
        }
        if (a.min <= b.min && a.max < b.max) {
          return 1;
        }
        if (a.min > b.min && a.max >= b.max) {
          return -1;
        }
        if (a.min >= b.min && a.max > b.max) {
          return -1;
        }

        return 0;
      });
    },
    getTerpenes(product) {
      const additionals = [];
      if (product.batches) {
        product.batches.forEach((batch) => {
          if (batch.terpenes.length > 0) {
            batch.terpenes.forEach((terp) => {
              if (!additionals.some((additional) => additional.name == terp.displayName && additional.type == terp.pivot?.measurement_type)) {
                additionals.push({
                  name: terp.displayName,
                  min: terp.pivot?.measurement,
                  max: terp.pivot?.measurement,
                  type: terp.pivot?.measurement_type,
                });
              } else {
                const index = additionals.findIndex(
                  (additional) => additional.name == terp.displayName && additional.type == terp.pivot?.measurement_type,
                );
                if (terp.pivot?.measurement < additionals[index].min) {
                  additionals[index].min = terp.pivot?.measurement;
                }
                if (terp.pivot?.measurement > additionals[index].max) {
                  additionals[index].max = terp.pivot?.measurement;
                }
              }
            });
          }
        });
      }
      return additionals.sort((a, b) => {
        if (a.min < b.min && a.max <= b.max) {
          return 1;
        }
        if (a.min <= b.min && a.max < b.max) {
          return 1;
        }
        if (a.min > b.min && a.max >= b.max) {
          return -1;
        }
        if (a.min >= b.min && a.max > b.max) {
          return -1;
        }

        return 0;
      });
    },
    getImageSrc(category) {
      const categoryName = category.name;
      let active = false;
      if (this.activeCategory.id == category.id) {
        active = true;
      }

      if (categoryName == "All Products") {
        if (active) {
          return "/img/icons/products-offered/all-products-white.svg";
        }
        return "/img/icons/products-offered/all-products.svg";
      }
      if (categoryName == "Pack To Order") {
        if (active) {
          return "/img/icons/products-offered/pack-order-white.svg";
        }
        return "/img/icons/products-offered/pack-order.svg";
      }
      if (categoryName == "Topicals & Wellness") {
        if (active) {
          return "/img/icons/products-offered/health-and-wellness-white.svg";
        }
        return "/img/icons/products-offered/health-and-wellness.svg";
      }
      if (categoryName == "Tincture") {
        if (active) {
          return "/img/icons/products-offered/tincture-white.svg";
        }
        return "/img/icons/products-offered/tincture.svg";
      }
      if (categoryName == "Edibles & Drink") {
        if (active) {
          return "/img/icons/products-offered/edibles-and-drink-white.svg";
        }
        return "/img/icons/products-offered/edibles-and-drink.svg";
      }
      if (categoryName == "Merchandise") {
        if (active) {
          return "/img/icons/products-offered/merchandise-white.svg";
        }
        return "/img/icons/products-offered/merchandise.svg";
      }
      if (categoryName == "Cartridge") {
        if (active) {
          return "/img/icons/products-offered/cartridge-white.svg";
        }
        return "/img/icons/products-offered/cartridge.svg";
      }
      if (categoryName == "Extract") {
        if (active) {
          return "/img/icons/products-offered/extract-white.svg";
        }
        return "/img/icons/products-offered/extract.svg";
      }
      if (categoryName == "Bulk Extract") {
        if (active) {
          return "/img/icons/products-offered/bulk-extract-white.svg";
        }
        return "/img/icons/products-offered/bulk-extract.svg";
      }
      if (categoryName == "Live Plant") {
        if (active) {
          return "/img/icons/products-offered/live-plant-white.svg";
        }
        return "/img/icons/products-offered/live-plant.svg";
      }
      if (categoryName == "Seed") {
        if (active) {
          return "/img/icons/products-offered/seed-white.svg";
        }
        return "/img/icons/products-offered/seed.svg";
      }
      if (categoryName == "Prepack") {
        if (active) {
          return "/img/icons/products-offered/prepack-white.svg";
        }
        return "/img/icons/products-offered/prepack.svg";
      }
      if (categoryName == "Preroll") {
        if (active) {
          return "/img/icons/products-offered/preroll-white.svg";
        }
        return "/img/icons/products-offered/preroll.svg";
      }
      if (categoryName == "Plant Material") {
        if (active) {
          return "/img/icons/products-offered/plant-material-white.svg";
        }
        return "/img/icons/products-offered/plant-material.svg";
      }
      if (categoryName == "Flower") {
        if (active) {
          return "/img/icons/products-offered/flower-white.svg";
        }
        return "/img/icons/products-offered/flower.svg";
      }
      return "";
    },
    sampleInCart(tableItem) {
      const foundItem = this.cartItems.find((item) => {
        if (tableItem.batches.length == 1) {
          if (item.batch_id == tableItem.batches[0].id && item.product_id == tableItem.id && item.sample) {
            return true;
          }
          return false;
        }

        if (item.product_id == tableItem.id && item.sample) {
          return true;
        }
        return false;
      });

      if (foundItem) {
        return true;
      }

      return false;
    },

    // quantityInCart(tableItem) {
    //   const foundItem = this.cartItems.find(
    //     (item) => {
    //       if (tableItem.batches.length == 1) {
    //         if ((item.batch_id == tableItem.batches[0].id) && (item.product_id == tableItem.id) && !item.sample) {
    //           return true;
    //         }
    //         return false;
    //       }
    //
    //       if ((item.product_id == tableItem.id) && !item.sample) {
    //         return true;
    //       }
    //       return false;
    //     },
    //   );
    //
    //   if (foundItem) {
    //     return `${foundItem.quantity.toString()}`;
    //   }
    //
    //   return '';
    // },

    quantityInCart(tableItem, returnValue = false) {
      let returnData = 0;
      if (this.cartItems && this.cartItems.length) {
        // if(tableItem.category_name === 'Pack To Order') {
        const foundItems = this.cartItems.filter((item) => {
          // (item.batch_id == tableItem.id) && (item.product_id == tableItem.product_id) && !item.sample,
          if (tableItem.batches.length == 1) {
            if (item.batch_id == tableItem.batches[0].id && item.product_id == tableItem.id && !item.sample) {
              return true;
            }
            return false;
          }

          if (item.product_id == tableItem.id && !item.sample) {
            return true;
          }
          return false;
        });

        for (let i = 0; i < foundItems.length; i += 1) {
          returnData += foundItems[i].quantity;
        }

        if (returnValue) {
          return Number(returnData);
        }

        return `${returnData.toString()}`;

        // const foundItem = this.cartItems.find(
        //   (item) => { // (item.batch_id == tableItem.id) && (item.product_id == tableItem.product_id) && !item.sample,
        //     if (tableItem.batches.length == 1) {
        //       if ((item.batch_id == tableItem.batches[0].id) && (item.product_id == tableItem.id) && !item.sample) {
        //         return true;
        //       }
        //       return false;
        //     }
        //
        //     if ((item.product_id == tableItem.id) && !item.sample) {
        //       return true;
        //     }
        //     return false;
        //   },
        // );

        // if (returnValue) {
        //   if (foundItem) {
        //     return Number(foundItem.quantity);
        //   }
        //   return 0;
        // }
        // else if (foundItem) {
        //   return `${foundItem.quantity.toString()}`;
        // }
      }

      return "";
    },

    countDecimals(value) {
      if (value % 1 != 0) {
        return value.toString().split(".")[1].length;
      }
      return 0;
    },
    addProductFromDisplayPage(data) {
      const item = {
        company_id: data.company_id,
        batch_id: data.batch_id,
        quantity: data.quantity,
        sample: data.sample,
        product_id: data.product_id,
      };
      const payload = { cartItems: [item] };
      this.$emit("addToCart", payload);
    },
    addSample(row) {
      const batchId = row.batches[0].id;
      const item = {
        company_id: row.company_id,
        batch_id: batchId,
        product_id: row.id,
        quantity: null,
        sample: true,
      };

      const data = { cartItems: [item] };
      this.$emit("addToCart", data);
    },
    singleAddCartItem(row) {
      const batchId = row.batches[0].id;
      if (this.onDeck[batchId] && this.onDeck[batchId].purchase_quantity && !this.onDeck[batchId].over_limit && !this.onDeck[batchId].decimalError) {
        const item = {
          batch_id: batchId,
          company_id: row.company_id,
          product_id: row.id,
          quantity: this.onDeck[batchId].purchase_quantity,
          sample: false,
        };
        const data = { cartItems: [item] };
        this.$emit("addToCart", data);
        delete this.onDeck[batchId];

        this.inputSlotKey += 1;
      }
    },
    removeQueueConfirmationModal() {
      this.isShowingRemoveQueueConfirmationModal = false;
    },
    updateOnDeckQuantity(updateObject) {
      let newQuantity = updateObject.purchase_quantity;
      if (
        newQuantity != "" &&
        newQuantity != "." &&
        newQuantity != ".0" &&
        newQuantity != ".00" &&
        newQuantity != ".000" &&
        newQuantity != ".0000" &&
        newQuantity != ".00000" &&
        newQuantity != ".000000"
      ) {
        newQuantity = Number(updateObject.purchase_quantity);
      }
      let decimalError = false;
      if (newQuantity % 1 != 0 && !this.categoryTypeCanHaveDecimal(updateObject.category_name, updateObject)) {
        decimalError = true;
      }

      const deckObject = {
        id: updateObject.batches[0].id,
        product_id: updateObject.id,
        company_id: updateObject.company_id,
        purchase_quantity: newQuantity,
        over_limit:
          !updateObject.batches[0].disable_inventory_tracking &&
          Number(newQuantity) + Number(this.quantityInCart(updateObject)) > Number(updateObject.batches[0].quantity),
        decimalError,
      };

      this.onDeck[deckObject.id] = deckObject;
    },

    quantityEnteredCheck(updateObject) {
      const enteredQuantity = Number(updateObject.purchase_quantity);
      let updateQuantity = null;
      if (enteredQuantity % 1 != 0 && !this.categoryTypeCanHaveDecimal(updateObject.category_name, updateObject)) {
        updateQuantity = parseInt(enteredQuantity, 10);
      }
      if (updateQuantity !== null) {
        const deckObject = {
          id: updateObject.batches[0].id,
          product_id: updateObject.id,
          purchase_quantity: updateQuantity,
          over_limit:
            !updateObject.batches[0].disable_inventory_tracking &&
            Number(updateQuantity) + Number(this.quantityInCart(updateObject)) > Number(updateObject.quantity),
          decimalError: false,
        };

        Object.defineProperty(this.onDeck, deckObject.id, {
          value: deckObject,
          writable: true,
          enumerable: true,
          configurable: true,
        });
      }
    },
    createPackToOrderItems(ptoObject) {
      this.ptoModalKey += 1;
      const data = { cartItems: [ptoObject] };
      this.$emit("addToCart", data);
    },
    createMultiBatchItems(multiBatchData) {
      // this.multiBatchModalKey += 1;
      const data = { cartItems: [multiBatchData] };
      this.$emit("addToCart", data);
    },
    pdpContactClicked() {
      this.hideProductDisplayPageModal();
      this.$emit("contactButtonClicked");
    },
    addAllOnDeck() {
      if (!this.onDeckError) {
        const items = [];

        for (const value of Object.values(this.onDeck)) {
          if (value.purchase_quantity) {
            items.push({
              company_id: value.company_id,
              batch_id: value.id,
              product_id: value.product_id,
              quantity: value.purchase_quantity,
              sample: false,
            });
          }
        }
        const data = { cartItems: items };

        this.$emit("addToCart", data);
        this.removeAllOnDeck();
      }
    },
    removeAllOnDeck() {
      this.onDeck = {};
      this.inputSlotKey += 1;
    },

    initiateCategoryChange(category) {
      this.resetTableIfFiltersSet();
      this.$nextTick(() => {
        if (this.onDeckCount) {
          this.onHoldCategory = category;
          this.isShowingRemoveQueueConfirmationModal = true;
        } else {
          this.continueChangingTab(category);
        }
      });
    },

    continueChangingTab(category) {
      this.removeAllOnDeck();
      this.isShowingRemoveQueueConfirmationModal = false;
      this.activeCategory = category;
      if (category.name == "All Products") {
        this.toggleFilter("category_long_display_name", "");
      } else {
        this.toggleFilter("category_long_display_name", category.long_display_name);
      }

      this.setTableColumns(category.name);
      if (category.name == "Merchandise") {
        this.groupByTabs = [{ name: "None", displayName: "None" }];
        if (this.groupBy == "Cultivar") {
          this.groupBy = "None";
        }
      } else {
        this.groupByTabs = [
          { name: "None", displayName: "None" },
          {
            name: "Cultivar",
            displayName: "Cultivar",
          },
        ];
      }
    },
    setPageLimit(recordsPerPage) {
      this.$refs.storefrontTable.setLimit(recordsPerPage);
      this.storefrontTableOptions.perPage = recordsPerPage;
    },
    // setPetFilter() {
    //   if (this.filteringByPets == 'no') {
    //     this.filteringByPets = 'only';
    //     this.toggleFilter('for_pets', 'Only');
    //   } else if (this.filteringByPets == 'only') {
    //     this.filteringByPets = 'hidden';
    //     this.toggleFilter('for_pets', 'None');
    //   } else {
    //     this.filteringByPets = 'no';
    //     this.toggleFilter('for_pets', 'All');
    //   }
    // },
    rowClicked(row) {
      if (!row.event.target.className.includes("no-pdp-click")) {
        this.launchProductDisplayPageModal(row);
      }
    },
    hideProductDisplayPageModal() {
      this.productCurrentlyShowingBulkDiscounts = [];
      this.selectedBatchId = null;
      this.showingProductDisplayModal = false;
    },
    launchProductDisplayPageModal(row) {
      const product = row.row;

      this.productDisplayPageModalKey += 1;
      this.selectedProductId = product.id;
      this.selectedBatchId = null;
      if (product.batches && product.batches.length == 1) {
        this.selectedBatchId = product.batches[0].id;
      }
      this.productCurrentlyShowingBulkDiscounts = this.bulkDiscounts.filter((discount) => {
        if (product.product_type_id) {
          return discount.product_type_id == product.type_id;
        }
        return discount.product_category_id == product.category_id;
      });

      this.showingProductDisplayModal = true;
    },
    openMultipleBatchModal(product) {
      this.selectedProductId = product.id;
      this.multiBatchModalKey += 1;
      this.isShowingMultiBatchModal = true;
    },

    handleSetColumn(category, column, value) {
      this.tableKey += 1;
      this.$nextTick(() => {
        this.setTableColumns(category);
        const foundCategory = this.productCategories.find((cat) => cat.name == category);
        this.initiateCategoryChange(foundCategory);
      });
    },

    resetTableIfFiltersSet() {
      const { storefrontTable } = this.$refs;
      if (storefrontTable.filtersCount > 1) {
        this.tableKey += 1;
      } else if (storefrontTable.filtersCount > 0 && this.activeCategory.name == "All Products") {
        this.tableKey += 1;
      }
    },

    setTableColumns(category) {
      const storefrontTableColumns = ["image", "category_long_display_name"];

      if (this.columnsEnabled.brand) {
        storefrontTableColumns.push("brand");
      }
      storefrontTableColumns.push("product_name");
      if (this.columnsEnabled.product_sku === true) {
        storefrontTableColumns.push("product_sku");
      }
      if (this.columnsEnabled.industry === true) {
        storefrontTableColumns.push("industry");
      }
      if (this.columnsEnabled.batch_name) {
        storefrontTableColumns.push("batch_name");
      }
      if (this.columnsEnabled.operation) {
        storefrontTableColumns.push("operation");
      }

      switch (category) {
        case "All Products":
          storefrontTableColumns.push("category_name", "product_type", "predominate_canabinoid");

          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (this.columnsEnabled.additional_cannabinoids) {
            storefrontTableColumns.push("additional_cannabinoids");
          }
          if (this.columnsEnabled.terpenes) {
            storefrontTableColumns.push("terpenes");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          if (this.columnsEnabled.extraction_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("extraction_date");
          }
          if (this.columnsEnabled.production_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("production_date");
          }
          if (this.columnsEnabled.best_by_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("best_by_date");
          }

          break;
        case "Plant Material":
          storefrontTableColumns.push("product_type", "predominate_canabinoid");
          if (this.industry == "hemp") {
            storefrontTableColumns.push("state_of_material");
          }
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          break;
        case "Flower":
          storefrontTableColumns.push("grow_environment", "product_type", "predominate_canabinoid");

          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (this.columnsEnabled.additional_cannabinoids) {
            storefrontTableColumns.push("additional_cannabinoids");
          }
          if (this.columnsEnabled.terpenes) {
            storefrontTableColumns.push("terpenes");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          break;
        case "Prepack":
          storefrontTableColumns.push("container_type", "packaged_unit_size", "predominate_canabinoid");
          if (this.columnsEnabled.additional_cannabinoids) {
            storefrontTableColumns.push("additional_cannabinoids");
          }
          if (this.columnsEnabled.terpenes) {
            storefrontTableColumns.push("terpenes");
          }
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          break;
        case "Preroll":
          storefrontTableColumns.push("preroll_type", "gram_per_preroll", "predominate_canabinoid");
          if (this.columnsEnabled.additional_cannabinoids) {
            storefrontTableColumns.push("additional_cannabinoids");
          }
          if (this.columnsEnabled.terpenes) {
            storefrontTableColumns.push("terpenes");
          }
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          break;
        case "Seed":
          storefrontTableColumns.push("predominate_canabinoid", "flowering_period", "germination_rate", "herm_male_rate");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          break;
        case "Live Plant":
          storefrontTableColumns.push("predominate_canabinoid", "flowering_period", "herm_male_rate");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          break;
        case "Bulk Extract":
          storefrontTableColumns.push("extract_type", "container_type", "predominate_canabinoid");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.extraction_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("extraction_date");
          }

          break;
        case "Extract":
          storefrontTableColumns.push("extract_type", "predominate_canabinoid");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.extraction_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("extraction_date");
          }
          break;
        case "Cartridge":
          storefrontTableColumns.push("cartridge_type", "unit_size", "predominate_canabinoid");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.extraction_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("extraction_date");
          }
          break;
        case "Topicals & Wellness":
          storefrontTableColumns.push("product_type", "unit_size", "predominate_canabinoid");
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.best_by_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("best_by_date");
          }
          break;
        case "Merchandise":
          // storefrontTableColumns.push(
          //   'listing_price',
          //   'quantity',
          // );
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          break;
        case "Edibles & Drink":
          storefrontTableColumns.push("product_type", "unit_size", "predominate_canabinoid");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.best_by_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("best_by_date");
          }
          break;
        case "Tincture":
          storefrontTableColumns.push("product_type", "unit_size", "predominate_canabinoid");
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.production_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("production_date");
          }
          break;
        case "Pack To Order":
          storefrontTableColumns.push("grow_environment", "container_type", "packaged_unit_size_options", "predominate_canabinoid");
          if (this.columnsEnabled.additional_cannabinoids) {
            storefrontTableColumns.push("additional_cannabinoids");
          }
          if (this.columnsEnabled.terpenes) {
            storefrontTableColumns.push("terpenes");
          }
          if (this.columnsEnabled.cultivar_name) {
            storefrontTableColumns.push("cultivar_name");
          }
          if (this.columnsEnabled.cultivar_type) {
            storefrontTableColumns.push("cultivar_type");
          }
          if (!this.hideQuantities) {
            storefrontTableColumns.push("quantity");
          }
          if (!this.hidePrices) {
            storefrontTableColumns.push("listing_price");
          }
          if (this.columnsEnabled.harvest_date && this.scope && this.scope.toLowerCase() == "batch") {
            storefrontTableColumns.push("harvest_date");
          }
          break;
        default:
        // nothing
      }
      if (this.columnsEnabled.for_pets) {
        storefrontTableColumns.push("for_pets");
      }
      if (!this.disableAdd) {
        storefrontTableColumns.push("inline_form");
      }
      this.storefrontTableColumns = storefrontTableColumns;
    },

    toggleFilter(filterName, value) {
      const columns = this.$refs.storefrontTable?.columns;
      if (!columns || columns.length == 0) {
        return;
      }
      this.$refs.storefrontTable.setPage(1);
      this.$refs.storefrontTable.setFilter({ [filterName]: value });
    },

    changeGroupByTab(tab) {
      this.activeGroupByTab = tab;
      if (tab == "None") {
        this.storefrontTableOptions.groupBy = null;
      } else if (tab == "Cultivar") {
        this.storefrontTableOptions.groupBy = "cultivar_name";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  --btnColor: #fff;
  --btnBgColor: #007bff;
}
.templateBtn:hover {
  background-color: rgb(0, 0, 0, 0.5);
}
.storefront-product-thumb {
  border-radius: 4px;
  -webkit-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 50px;
  width: 50px;
  border: 1px solid #ced4da;
}

.image-floater {
  z-index: 10000;
  position: fixed;
  top: 40%;
  left: 50%;
  width: 500px;
  height: 500px;
  margin-top: -280px;
  margin-left: -250px;
  border-radius: 10px;
}

.table-shadow {
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.2),
    0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12);
}

:deep(.theme-enabled .headerDropdown .dropdown .btn) {
  background-color: #ffffff;
  color: var(--bg-color) !important;
}

:deep(.theme-enabled .templateDropdown .dropdown .btn) {
  background-color: var(--bg-color) !important;
  color: var(--color) !important;
}

:deep(.theme-enabled .page-item .page-link) {
  color: var(--bg-color) !important;
}

:deep(.theme-enabled .page-item .active) {
  background-color: var(--bg-color) !important;
  color: var(--color) !important;
  border: 1px solid #e5e8eb !important;
  box-shadow: none !important;
}

:deep(.hide-pagination .VuePagination) {
  display: none !important;
}

:deep(.theme-enabled li a.dropdown-item.active, li a.dropdown-item:active) {
  background-color: var(--bg-color) !important;
  color: var(--color) !important;
}

.storefront-color {
  color: var(--color) !important;
}

.inverted-storefront-color {
  color: var(--bg-color) !important;
}

.storefront-background-color {
  background-color: var(--bg-color) !important;
}

.templateButton {
  background-color: var(--bg-color) !important;
  color: var(--color) !important;
}

.templateButtonBorder {
  border: 1px solid var(--bg-color) !important;
}

:deep(.theme-enabled .table-info, .theme-enabled .table-info > th, .theme-enabled .table-info > td) {
  background-color: var(--bg-color) !important;
  color: var(--color) !important;
}
:deep(.theme-enabled .table-info th, .theme-enabled .table-info td, .theme-enabled .table-info thead th, .theme-enabled .table-info tbody + tbody) {
  border-color: var(--bg-color);
}

.btn-custom {
  background-color: var(--btnBgColor) !important;
  color: var(--btnColor) !important;
}

.btn-custom:hover {
  opacity: 0.9;
}

.btn-custom:disabled {
  opacity: 0.5;
}
</style>
